import axios, { AxiosPromise } from 'axios';
import { ISearchResult } from '../models/Search/ISearchResult';

const instance = axios.create({
  baseURL: '/',
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false,
});

function searchService() {
  function getSearchResults(searchParam: String): AxiosPromise<ISearchResult> {
    return instance.get('/api/search', {
      params: {
        q: searchParam,
      },
    });
  }
  return { getSearchResults };
}

export default searchService;
